import React from "react";
import { format, subMonths, addMonths, startOfMonth, endOfMonth, startOfWeek, endOfWeek, addDays, isSameMonth, isSameDay} from "date-fns";
import './calender.scss';
import Cookies from "js-cookie";
import axiosSpace from "../../../../../axios/axios_spacetag";
import apiConfig from "../../../../../axios/axios_api_services";
import * as common from "../../../../../const/Common/CommonFunc";
import * as actionCreator from "../../../../../store/Action";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import * as time_convertor_utils from "../../../../../util/TimeConvertor";
import moment from 'moment';

class Calendar extends React.Component {
    state = {
        currentMonth: new Date(),
        selectedDate: new Date(),
        cell: <div className="body"></div>,
        reservationData: null,
    };


  componentDidMount() {
      const { currentMonth, selectedDate } = this.state;
      const monthStart = startOfMonth(currentMonth);
      const monthEnd = endOfMonth(monthStart);
      const startDate = startOfWeek(monthStart);
      const endDate = endOfWeek(monthEnd);

      this.setState({
        currentMonth: new Date(),
        selectedDate: new Date(),
      });

    if(this.props.data !== null && this.props.data !== undefined) {
      let renderCells1 = this.renderCells();
      this.setState({
        cell: renderCells1
      });
      this.callDataFromBackend(time_convertor_utils.DateObjTOStringYYYYMMdd(startDate), time_convertor_utils.DateObjTOStringYYYYMMdd(endDate), currentMonth);
    } else {
      let renderCells1 = this.renderCells();
      this.setState({
        cell: renderCells1
      });
    }

    }

    recallCell = (cm) => {

      let renderCells1 = this.renderCells(cm);
      this.setState({
        cell: renderCells1
      });
    };

    callDataFromBackend = (startDate, endDate, cm) => {

      let corporateId = this.props.usr_obj.corporates[0].corporateId;
      let workspaceId = this.props.data.workSpaceId;

      const headers = {
        "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
      };

      this.props.spinnerHandler(true);
      axiosSpace.get(apiConfig.ST_GET_RESERVATION_DATA_OF_WORKSPACE({workspaceId: workspaceId, corporateId: corporateId, startDate: startDate, endDate: endDate}), {headers: headers})
        .then(response => {
          if (response.data.success) {
                let reservationList = response.data.reservationList;
                this.setState({
                  reservationData: reservationList
                });
          } else {

          }
        })
        .catch(async error => {

          let result = await common.checkErrorResponse(error);
          if (result === 1) {
            this.callDataFromBackend(startDate, endDate);
          }
        })
        .finally(fin => {
          this.props.spinnerHandler(false);
          this.recallCell(cm);
        });
    };

    renderCells = (cm) => {
      let currentMonth = cm;
      let selectedDate = this.state.selectedDate;

      const monthStart = startOfMonth(currentMonth);
        const monthEnd = endOfMonth(monthStart);
        const startDate = startOfWeek(monthStart);
        const endDate = endOfWeek(monthEnd);

        const dateFormat = "d";
        const rows = [];

        let days = [];
        let day = startDate;
        let formattedDate = "";

      let reservationDatax = this.state.reservationData;
      let reservationData = null;
      if(reservationDatax !== null && reservationDatax !== undefined && reservationDatax !== "") {
        reservationData = reservationDatax.slice();
      }

        while (day <= endDate) {
            for (let i = 0; i < 7; i++) {
                formattedDate = format(day, dateFormat);
                const cloneDay = day;

              let todaySlotBookedCount = 0;
              let todaySlotFreeCount = 0;
              // let reservationData = this.state.reservationData;
              let reservationDatum = null;
              let reservationSlot = null;


              let mm = (cloneDay.getMonth() + 1).toString().length === 1? ("0" + (cloneDay.getMonth() + 1)) : (cloneDay.getMonth() + 1);
              let dd = cloneDay.getDate().toString().length === 1? ("0" + cloneDay.getDate()) : cloneDay.getDate();

              let d = cloneDay.getFullYear() + "-" + mm + "-" + dd;

              if(reservationData !== null && reservationData !== undefined && reservationData !== "") {
                if(reservationData.length!==0) {
                  let totalSlotCount = this.props.data.totalSlotCount;
                  todaySlotFreeCount = this.props.data.totalSlotCount;
                  for(let k = 0; k<reservationData.length; k++) {
                    reservationDatum = reservationData[k];
                    if(moment(reservationDatum.date).isSame(d)) {
                      reservationSlot = reservationDatum;
                      todaySlotBookedCount = reservationDatum.todaySlotBookedCount;
                      todaySlotFreeCount = totalSlotCount - todaySlotBookedCount;
                    }
                  }

                } else {
                  todaySlotFreeCount = this.props.data.totalSlotCount;
                }

              }

                days.push(
                    <div
                        className={`col cell ${
                            !isSameMonth(day, monthStart)
                                ? "disabled"
                                : isSameDay(day, selectedDate) ? "selected" : ""
                        }`}
                        key={day}
                        onClick={() => this.props.goSlotView( reservationSlot, d )}
                    >
                        <span className="number">{formattedDate}</span>
                        <span className="bg">{formattedDate}</span>
                        <div className="slot">
                            <table>
                                <tbody>
                                <tr className={ "reserved-lbl" }>
                                    <td>Reserved</td>
                                    <td>: { todaySlotBookedCount }</td>
                                </tr>
                                <tr className={ "remain-lbl" }>
                                    <td>Free</td>
                                    <td>: { todaySlotFreeCount }</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                );
                day = addDays(day, 1);
            }
            rows.push(
                <div className="row" key={day}>
                    {days}
                </div>
            );
            // if(reservationData !== null) {
            //   reservationData.splice(0, 7);
            // }
            days = [];
        }
        return <div className="body">{rows}</div>;
    };

    onDateClick = day => {
        this.setState({
            selectedDate: day
        });
    };

    nextMonth = () => {
        this.setState({
            currentMonth: addMonths(this.state.currentMonth, 1)
        });
      this.callCells(addMonths(this.state.currentMonth, 1));
      // this.testCall();
    };

    prevMonth = () => {
        this.setState({
            currentMonth: subMonths(this.state.currentMonth, 1)
        });
      this.callCells(subMonths(this.state.currentMonth, 1));
    };

    callCells = (cm) => {

      const monthStart = startOfMonth(cm);
      const monthEnd = endOfMonth(monthStart);
      const startDate = startOfWeek(monthStart);
      const endDate = endOfWeek(monthEnd);

      this.callDataFromBackend(time_convertor_utils.DateObjTOStringYYYYMMdd(startDate), time_convertor_utils.DateObjTOStringYYYYMMdd(endDate), cm);

    };

    render() {

      let days = [];
      for (let i = 0; i < 7; i++) {
        days.push(
          <div className="col col-center" key={i}>
            {x[i]}
          </div>
        );
      }


        return (
            <div className="calendar">
                <div className="header row flex-middle">
                  <div className="col col-start">
                    <div className="icon" onClick={this.prevMonth}>
                      {/*chevron_left*/}
                      <i aria-hidden="true" className="angle left icon"></i>
                    </div>
                  </div>
                  <div className="col col-center">
                    <span>{format(this.state.currentMonth, "MMMM yyyy")}</span>
                  </div>
                  <div className="col col-end" onClick={this.nextMonth}>
                    <div className="icon">
                      {/*chevron_right*/}
                      <i aria-hidden="true" className="angle right icon"></i>
                    </div>
                  </div>
                </div>
              <div className="days row">{days}</div>
              {this.state.cell}
            </div>
        );
    }
}

const x = [
  'Sun',
  'Mon',
  'Tue',
  'Wed',
  'Thu',
  'Fri',
  'Sat'
];

const mapStateToProps = (state) => ({
  usr_obj: state.userReducer.user,
  workspace: state.workspaceReducer.workspace
});

const mapDispatchToProps = (dispatch) => {
  return {
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Calendar));
